module.exports = __webpack_public_path__ + "p8_img2.jpg?1d9430d1489b8c2210f88b3a63d96452";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img2.jpg
// module id = 62
// module chunks = 0